<template>
  <div>
    <UploadImageCautionArea :cautions="cautions" class="mb-4">
      ※インカメラでの撮影を推奨します
    </UploadImageCautionArea>
    <UploadImageForm
      v-model="inputValues.avatar"
      photoGraphingType="avatar"
      appLabelText="必須"
      appLabelVariant="red"
      v-model:isCameraActive="isCameraActiveValue"
      :options="options"
      :disabled="disabled"
      :disabledText="disabledText"
    >
      <AvatarImage :imageUrl="inputValues.avatar" />
    </UploadImageForm>
  </div>
</template>

<script lang="ts">
import AvatarImage from "@/components/molecules/other/AvatarImage.vue";
import UploadImageCautionArea from "@/components/molecules/other/UploadImageCautionArea.vue";
import UploadImageForm from "@/components/organisms/register/UploadImageForm.vue";
import { AvatarInputValues } from "@/types/user/RequestVerificationQueueBody";
import { Component, Prop, Vue } from "vue-facing-decorator";

@Component({
  components: {
    UploadImageForm,
    UploadImageCautionArea,
    AvatarImage
  }
})
export default class SetAvatar extends Vue {
  @Prop({
    type: Object,
    required: true
  })
  value!: AvatarInputValues;

  @Prop({
    type: Boolean,
    required: true
  })
  isCameraActive!: boolean;

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean;

  @Prop({
    type: String,
    default: ""
  })
  disabledText!: string;

  get inputValues() {
    return this.value;
  }

  set inputValues(v) {
    if (this.value !== v) this.$emit("input", v);
  }

  get isCameraActiveValue() {
    return this.isCameraActive;
  }

  set isCameraActiveValue(v) {
    this.$emit("update:isCameraActive", v);
  }

  get options() {
    return [
      "正面を向いていますか？",
      "顔がはっきり見えますか？",
      "人やものは映り込んでいませんか？"
    ];
  }

  get cautions() {
    return [
      "画像が不鮮明で加工していないこと",
      "首から上が写されていること",
      "正面を向いていること",
      "ご本人の写真であること"
    ];
  }
}
</script>
